module.exports = __webpack_public_path__ + "media/sounds/tap_05-15cce76f14906159d9a6f83cbc971871.wav";